import React, { useEffect, useState } from "react";
import { Card, CardBody } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import { getDealsAssignedToCIUsers } from "http/UAM/userDashboardWidget.helper";
import NoDataChart from "pages/EntityMoreInformation/NoDataComponent";

const UserAssigned = ({ userType }) => {

  const [data, setData] = useState([]);
  const [showStatus, setShowStatus] = useState(true)

  useEffect(() => {
    getDealsAssignedToCIUsers().then((res) => {
      if (res.status) {
        setData(res.data);
        setShowStatus(true)
      } else {
        setShowStatus(false)
        setData([]);
      }
    });
  }, [])
  const xAxisdata = data
  ?.toSorted((a, b) => b.dealCount - a.dealCount)
  ?.map((financier) => `${financier['assignedToUser.first_name']} ${financier['assignedToUser.last_name'] || ""}`);
 while (xAxisdata.length < 6) {
    xAxisdata.push(" ")
  }

  const options = {
    chart: {
      type: "bar",
      height: 500,
    },
    plotOptions: {
      bar: {
        horizontal: true,
        endingShape: "flat",
        columnWidth: '50%',
        borderRadius: 0,
        dataLabels: {
          position: "center",
        },
      },
    },
    colors: [
      function ({ dataPointIndex }) {
        switch (dataPointIndex) {
          case 0:
            return "#00c5dc";
          case 1:
            return "#f46a6a";
          case 2:
            return "#34c38f";
          case 3:
            return "#3f9ae5";
          case 4:
            return "#f1b44c";
          default:
            return "#0174BE";
        }
      },
    ],
    stroke: {
      width: 1,
      colors: ["#fff"],
    },
    xaxis: {
      title: {
        text: "Deals",
      },
      categories: xAxisdata,
    },
    yaxis: {
      title: {
        text: 'Deals'
      }
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val + " deals";
        },
      },
    },
  };

  return (
    <Card>
      {showStatus ?  <CardBody>
        <h4 className="card-title mb-2">
          {`Deals Assigned to CI Users`}
        </h4>
        <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }} className="mb-2">
        </div>
        <div style={{ maxWidth: '100%', maxHeight: '320px' }} className='vertical-scroll'>
          <ReactApexChart
            options={options}
            series={[{ name: "", data: data?.toSorted((a, b) => b.dealCount - a.dealCount)?.map((financier) => financier.dealCount) }]}
            type="bar"
            height={data.length > 6 ? data.length * 50 : 300}
          />
        </div>
      </CardBody>
        : <NoDataChart title='No Information Found' subtitle="No Deal Assigned to CI User" />}
    </Card>
  );
};

export default UserAssigned;
